import { IntercomProvider as ReactIntercomProvider } from 'react-use-intercom';
import { Box, styled } from '@applatform/design-system';
import { intercomAppId, isProductionBuild } from 'utils/env';

// Styles to imitate the Intercom button
const FakeIntercomButton = styled(Box, {
  position: 'fixed',
  zIndex: 2147483003,
  bottom: 20,
  right: 20,
  width: 60,
  height: 60,
  borderRadius: '50%',
  background: '#6738BD',
  boxShadow: '0 1px 6px 0 rgb(0 0 0 / 6%), 0 2px 32px 0 rgb(0 0 0 / 16%)',
});

/*
  Wraps ReactIntercomProvider to control which environments load the Intercom widget.
  It displays a dummy button in environments when Intercom isn't loaded.
*/
export function IntercomProvider(props: { children: React.ReactNode }) {
  return (
    <ReactIntercomProvider appId={String(intercomAppId)}>
      {props.children}
      {!isProductionBuild && <FakeIntercomButton />}
    </ReactIntercomProvider>
  );
}
